import {useMutation} from '@apollo/client';
import {DELETE_ALL_CART} from "../productTypeDefs";

export const useMutationDeleteAllCart = (options?: any): any => (
  useMutation(DELETE_ALL_CART, options)
);
